import {
  Box,
} from '@chakra-ui/react';
import { Outlet } from 'react-router-dom';
import './AdminLayout.css';

const AdminLayout = () => {
  
  return (
    <Box className="admin-layout">
      {/* Content */}
      <Box className="admin-content">
        <Outlet />
      </Box>
    </Box>
  );
};

export default AdminLayout;

